const en = {
  '{count} entry': { one: '{count} entry', other: '{count} entries' },
  '{count} lines': { one: '{count} line', other: '{count} lines' },
  '{count} products': { one: '{count} product', other: '{count} products' },
  '{count} variances': { one: '{count} variance', other: '{count} variances' },
  '+{count} more': { one: '+{count} more', other: '+{count} more' },
  '{count} lines were never counted and will be set to zero.': {
    one: '{count} line was never counted and will be set to zero.',
    other: '{count} lines were never counted and will be set to zero.',
  },
  '{count} documents will be created, each counted and finalised on its own.': {
    one: '{count} document will be created, counted and finalised on its own.',
    other: '{count} documents will be created, each counted and finalised on its own.',
  },
  "{count} elements": { one: "{count} element", other: "{count} elements" },
  "{count} restrictions": { one: "{count} restriction", other: "{count} restrictions" },
  "{count} pages allowed": { one: "{count} page allowed", other: "{count} pages allowed" },
  "{count} cards": { one: "{count} card", other: "{count} cards" },
  "{count} users": { one: "{count} user", other: "{count} users" },
  "{count} differences": { one: "{count} difference", other: "{count} differences" },
  "{count} unsaved changes": { one: "{count} unsaved change", other: "{count} unsaved changes" },
  "Saved. Access is updated straight away for {count} people.": { one: "Saved. Access is updated straight away for {count} person.", other: "Saved. Access is updated straight away for {count} people." },
  "{count} groups": { one: "{count} group", other: "{count} groups" },
  "{count} pages": { one: "{count} page", other: "{count} pages" },
};

export default en;
